<template>
  <div class="lectors my-16 px-4 px-md-10">
    <div class="lectors__header d-flex align-center justify-space-between">
      <div class="lectors__header-title">
        <h2>{{ commonData.lecturesTitle }}</h2>
      </div>
      <div class="lectors__header-btn">
        <v-btn class="secondary-btn" outlined to="/lectors">
          <div class="d-none d-sm-block">
            {{ commonData.lecturesButtonTitle }}
          </div>
          <v-icon :right="$vuetify.breakpoint.smAndUp">mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="lectors__carousel mt-5">
      <VueSlickCarousel
        style="position: static"
        v-bind="settings"
        ref="lectors-carousel"
        v-if="lectors.length"
      >
        <lector
          v-for="(lector, index) in lectors"
          :key="index"
          :person="lector"
          class="px-3 elevation-0 rounded-0 py-4"
        ></lector>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import lector from "@/components/lector";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Lectors",
  components: {
    VueSlickCarousel,
    lector
  },
  computed: {
    lectors() {
      return this.$t("lectors").lectors;
    },
    commonData() {
      return this.$t("common");
    }
  },

  data: () => ({
    settings: {
      arrows: true,
      dots: true,
      autoplay: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      speed: 300,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true
          }
        }
      ]
    }
  })
};
</script>

<style lang="sass" scoped>
.lectors
  position: relative
  width: 100%
</style>

<style lang="sass">
@media (max-width: 600px)
  .lectors
    &__carousel
      .slick-dots
        display: none !important

.lectors
  position: relative !important
  &__carousel
    .slick-dots
      position: absolute
      top: .8rem
      left: 25%
      li button
        &:before
          content: ''
          width: .5rem !important
          height: .5rem !important
          background-color: #2F2E43
          border-radius: 50%
          display: block
</style>
